// theirs
import styled from 'styled-components'
// ours
import { PhotoGalleryProps } from '.'
import { breakpoints, color, typography } from '../../../styles'

export const photoGalleryBaseClass = 'photo-gallery'

export const StyledPhotoGallery = styled.div<PhotoGalleryProps>`
    &.${photoGalleryBaseClass} {
        background-color: ${(props) => props.content.contentBackgroundColor};
        background-repeat: no-repeat;
        background-size: cover;
        padding: 0;
        margin: 0;
        position: relative;
        height: 100%;
        width: 100%;
        display: grid;
        grid-template-rows: ${(props) =>
            props.doesHaveNextChapter ? '50% 50%' : 'auto'};

        .content-outer {
            justify-content: center;
            justify-items: center;
        }

        .content-inner {
            max-width: 550px;
            margin: 0 auto;
            display: grid;
            grid-gap: 1rem;
            grid-template-rows: 1fr;

            height: 100%;

            @media (min-width: ${breakpoints.sm}) {
                max-width: 750px;
            }

            @media (min-width: ${breakpoints.lg}) {
                grid-gap: 0;
                max-width: fit-content;
                grid-template-columns: 1fr;
                grid-template-rows: auto;
            }
        }

        .image-wrapper {
            align-self: center;
            display: grid;
            overflow: auto;
            grid-gap: 2rem;
            grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;

            picture img {
                max-width: 300px;

                @media (min-width: ${breakpoints.lg}) {
                    max-width: 500px;
                }
            }

            picture {
                &:first-child {
                    margin-left: 2rem;

                    @media (min-width: ${breakpoints.lg}) {
                        margin-left: 10rem;
                    }
                }

                &:last-child {
                    margin-right: 2rem;

                    @media (min-width: ${breakpoints.lg}) {
                        margin-right: 10rem;
                    }
                }

                &:nth-child(1) {
                    padding-top: 9.5rem;
                }

                &:nth-child(2) {
                    padding-top: 9.5rem;
                }

                &:nth-child(3) {
                    padding-top: 0;
                }

                &:nth-child(4) {
                    padding-top: 11.5rem;

                    img {
                        max-width: 200px;
                    }
                }

                &:nth-child(5) {
                    align-self: end;
                    padding-bottom: 8.5rem;
                }

                &:nth-child(6) {
                    align-self: end;
                    padding-bottom: 8.5rem;
                }

                &:nth-child(7) {
                    align-self: end;
                    padding-bottom: 8.5rem;
                }

                .picture-text {
                    font-family: ${typography.type.secondary};
                    font-weight: ${typography.weight.bold};
                    font-style: ${typography.style.normal};
                    font-size: ${typography.size.s3};
                    color: ${color.cadmiumpurple};
                    text-transform: uppercase;
                }
            }
        }
    }
`
